
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/referrer-dashboard",
      function () {
        return require("private-next-pages/referrer-dashboard.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/referrer-dashboard"])
      });
    }
  